
































import Vue from "vue";
import PanaceaBox from "../components/PanaceaBox.vue";

export default Vue.extend({
    components: {
        PanaceaBox,
    },
});
